"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var material_1 = require("@mui/material");
var material_2 = require("@mui/material");
var svgs_1 = require("../../assets/svgs");
var Thumbprint_png_1 = __importDefault(require("../../assets/svgs/Thumbprint.png"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var ThemedDialogTitle = (0, material_1.styled)(DialogTitle_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        padding: '4.0rem',
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary[600],
    });
});
var DialogTitleWrapper = function (_a) {
    var title = _a.title, onClose = _a.onClose, handleChange = _a.handleChange, description = _a.description, backActionDescription = _a.backActionDescription, props = __rest(_a, ["title", "onClose", "handleChange", "description", "backActionDescription"]);
    var _b = (0, react_1.useState)(false), parentHover = _b[0], setParentHover = _b[1];
    return ((0, jsx_runtime_1.jsxs)(ThemedDialogTitle, __assign({}, props, { sx: { paddingBottom: description ? '8.8rem' : '' } }, { children: [(0, jsx_runtime_1.jsx)(material_2.Box, { sx: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    opacity: '0.3',
                    backgroundImage: "url(".concat(Thumbprint_png_1.default, ") "),
                } }), (0, jsx_runtime_1.jsx)(material_2.Box, { sx: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(270deg, #191933 8.78%, rgba(25, 25, 51, 0) 100%)',
                } }), (0, jsx_runtime_1.jsxs)(material_2.Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsxs)(material_2.Stack, __assign({ direction: 'row', sx: { alignItems: 'flex-start' } }, { children: [handleChange && ((0, jsx_runtime_1.jsxs)(material_2.Stack, __assign({ direction: 'row', sx: { alignItems: 'center', marginRight: '2.4rem' } }, { children: [(0, jsx_runtime_1.jsx)(material_2.Box, __assign({ onMouseOver: function () { return setParentHover(true); }, onMouseOut: function () { return setParentHover(false); }, onClick: function (e) { return handleChange(e, 0); }, sx: {
                                            height: '3.2rem',
                                            color: 'white.main',
                                            cursor: 'pointer',
                                            borderRadius: '50%',
                                            position: 'relative',
                                            '&:hover': {
                                                backgroundColor: 'primary.main',
                                                borderRadius: '999',
                                            },
                                        } }, { children: parentHover ? (0, jsx_runtime_1.jsx)(svgs_1.ArrowSmallNoCircle, {}) : (0, jsx_runtime_1.jsx)(svgs_1.ArrowSmall, {}) })), backActionDescription && ((0, jsx_runtime_1.jsx)(material_2.Typography, __assign({ sx: {
                                            paddingLeft: '1.2rem',
                                            color: 'white.main',
                                        } }, { children: backActionDescription })))] }))), (0, jsx_runtime_1.jsxs)(material_2.Stack, __assign({ direction: 'column' }, { children: [(0, jsx_runtime_1.jsx)(material_2.Typography, __assign({ variant: "headlineMedium", sx: { zIndex: 9999 } }, { children: title })), description && ((0, jsx_runtime_1.jsx)(material_2.Typography, __assign({ variant: "bodyMedium", sx: {
                                            color: 'primary.300',
                                            position: 'absolute',
                                            marginTop: '3rem',
                                            paddingRight: '4.0rem',
                                        } }, { children: description })))] }))] })), onClose && ((0, jsx_runtime_1.jsx)(material_2.IconButton, __assign({ onClick: onClose, size: "small", sx: {
                            width: '2.6rem',
                            height: '2.6rem',
                            color: 'rgba(255,255,255,0.4)',
                            border: '2px',
                            borderStyle: 'solid',
                            borderColor: 'common.white',
                            borderRadius: '0.7rem',
                            minWidth: 0,
                            '&:hover': {
                                borderColor: 'primary.main',
                                backgroundColor: 'primary.main',
                                color: 'common.white',
                            },
                        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.Union, {}) })))] }))] })));
};
exports.default = DialogTitleWrapper;
